import { useState } from "react";
import ContactOptions from "./ContactOptions";
import TableDatalis from "./TableDatalis";
import regx from "../../../../functions/regx";

export default ({data, setData}) => {
    const templateContact = {1: {select: "פלאפון", input: ""}, 2: {select: "טלפון בית", input: ""}, 3: {select: "אמייל", input: ""}, 4: {select: "פקס", input: ""}}
    const [contactData, setContactData] = useState(templateContact);
    const head = ["מס'", "סוג", "תוכן", ""];

    function insertContact () {
        let contact = {};
        const keys = Object.keys(data.contact);
        let num = (keys.length ? Math.max(...keys) : 0) + 1;
        console.log(num);
        Object.values(contactData).map((value) => {
            let pattern = value.select === "אמייל" ? "email" : "phone"
            if (regx(pattern, value.input, false)) {
                contact[num] = {type: value.select, data: value.input};
                num ++;
            }
        })
        setData({...data, contact: {...data.contact, ...contact}})
        setContactData(templateContact);
    }

    return (
        <div>
            <div className="ContactOptionDiv">
                {
                    [1, 2, 3, 4].map((value) => 
                        <ContactOptions
                        data={contactData[value]}
                        setData={(key, valueContact) => setContactData({...contactData, [value]: {...contactData[value], [key]: valueContact}})}
                        />
                    )
                }
            </div>

            <p onClick={insertContact} className="addPasspord"> הוסף \ עדכן</p>

            <TableDatalis 
            name={'contact'} 
            head={head} 
            data={data.contact}
            myDelete={(value) => {
                let contact = data.contact;
                delete contact[value];
                setData({...data, contact: {...contact}});
            }}
            />
        </div>
    )
}